/* React Higher Order Component which fetches activity saves for activity where activityId = props.activityId. Sasves data will refresh via poll and pass changes via props
    child will receive props: {
        activitySaves: PropTypes.array
        onToggleActivitySavesPoll: PropTypes.func
    }
*/

import React from 'react';
import PropTypes from 'prop-types';

const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelStoreState: PropTypes.shape({ channel: PropTypes.shape({ user_permissions: PropTypes.object.isRequired }) }).isRequired,
    projectStoreState: PropTypes.shape({ project: PropTypes.shape({ user_permissions: PropTypes.object.isRequired }) }).isRequired,
    documentVisible: PropTypes.bool.isRequired,
    disablePolling: PropTypes.bool,
};
const defaultProps = {
    disablePolling: false,
};
const POLL_ACTION_ID = 'activity-saves-poll';

export default function withActivitySavesPoll(WrappedComponent) {
    class WithActivitySavesPoll extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                activitySaves: ActivityStore.getStateActivity(
                        props.activityId,
                        props.projectId,
                        props.channelId
                    ).activitySaves,
                disablePolling: false,
                fatalError: null
            }

            this.refreshSavesData = this.refreshSavesData.bind(this);
            this.onTogglePolling = this.onTogglePolling.bind(this);
            this.unsubscribes = [ActivityStore.listen(this.onActivityStoreChange.bind(this))];
        }

        UNSAFE_componentWillMount() {
            const self = this;
            this.refreshSavesData(true);
            this.updateSavesInterval = window.setInterval(self.refreshSavesData, 60000);
        }

        componentWillUnmount() {
            window.clearInterval(this.updateSavesInterval);
            this.unsubscribes.forEach(u => u());
        }

        onActivityStoreChange(newState) {
            this.setState({
                activitySaves: ActivityStore.getStateActivity(
                    this.props.activityId,
                    this.props.projectStoreState.project.id,
                    this.props.channelStoreState.channel.id
                    ).activitySaves,
            });
        }

        refreshSavesData(init=false) {
            if (
                !init
                && (
                    !this.props.documentVisible
                    || this.props.disablePolling
                    || this.state.disablePolling
                )
            ) {
                return;
            }

            const project = this.props.projectStoreState.project;
            const channel = this.props.channelStoreState.channel;
            if (!project || !channel) {
                return;
            }

            ActivityActions.getActivitySaves(
                POLL_ACTION_ID,
                { activityId: this.props.activityId }
            );
        }

        onTogglePolling(pollBool) {
            this.setState({ disablePolling: pollBool });
        }

        render() {
            if (!this.state.activitySaves) {
                return null;
            }

            return (
                <WrappedComponent
                    {...this.props}
                    activitySaves={this.state.activitySaves}
                    onToggleActivitySavesPoll={this.onTogglePolling}
                />
            );
        }
    }

    WithActivitySavesPoll.propTypes = propTypes;
    WithActivitySavesPoll.defaultProps = defaultProps;
    WithActivitySavesPoll.displayName = `WithActivitySavesPoll(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithActivitySavesPoll;
}
